import { Plant } from './plant';

export interface PlantsResponse {
  plants: Plant[];
}
